import { Box, Button } from '@mui/material';
import BaseSelectorUI from 'components/BaseSelectorUI';
import DatePicker from 'components/DatePicker';
import { DateRangeOptions, StartEndDates } from '@constants';
import { MouseEventHandler } from 'react';

type DateRangeOptionSelectorUIProps = {
  onClick: MouseEventHandler<HTMLElement>;
  selectorLabel: string;
  startDateLabel?: string;
  endDateLabel?: string;
  //start and end date are only for custom dates DateRangeOptions.Custom
  startDate?: string;
  endDate?: string;
  showEndDate?: boolean;
  dateRangeOption: DateRangeOptions;
  onCustomDateChange: (args: { name: StartEndDates; value: string }) => void;
};

export const DateRangeOptionSelectorUI = ({
  selectorLabel,
  onClick,
  dateRangeOption,
  startDate,
  endDate,
  showEndDate = false,
  startDateLabel = 'Start Date',
  endDateLabel = 'End Date',
  onCustomDateChange,
}: DateRangeOptionSelectorUIProps) => {
  return (
    <Box display={'flex'} alignItems={'center'} gap={20}>
      <BaseSelectorUI
        onClick={onClick}
        label={
          <Button variant="outlined" color="primary">
            {selectorLabel}
          </Button>
        }
      />
      {dateRangeOption === DateRangeOptions.Custom ? (
        <Box display={'flex'} gap={10}>
          <DatePicker
            label={startDateLabel}
            value={startDate}
            onChange={(newDate) =>
              onCustomDateChange({
                name: StartEndDates.StartDate,
                value: newDate ?? '',
              })
            }
          />
          {showEndDate ? (
            <DatePicker
              label={endDateLabel}
              value={endDate}
              onChange={(newDate) =>
                onCustomDateChange({
                  name: StartEndDates.EndDate,
                  value: newDate ?? '',
                })
              }
            />
          ) : (
            <></>
          )}
        </Box>
      ) : (
        <></>
      )}
    </Box>
  );
};
